module.exports = __webpack_public_path__ + "static/allcomforters1-19466c85524478cd94d65a6e5b349013.jpeg";